import type { ChangeEventHandler, SyntheticEvent } from 'react';
import { DefaultEditor } from 'react-simple-wysiwyg';
import FieldWrapper, { FieldWrapperProps } from './FieldWrapper';
import classes from './RichTextField.module.scss';

export default function RichTextField({
  name,
  sx,
  value,
  ...rest
}: RichTextFieldProps) {
  const editorProps = {
    name,
  };

  function onChange(event: SyntheticEvent<HTMLDivElement>) {
    rest.onChange?.({
      ...event,
      target: { name, ...event.target },
    } as any);
  }

  return (
    <FieldWrapper {...rest} sx={{ width: '100%', ...sx }}>
      <div className={classes.root}>
        <DefaultEditor {...editorProps} onChange={onChange} value={value} />
      </div>
    </FieldWrapper>
  );
}

export interface RichTextFieldProps extends FieldWrapperProps {
  name?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value?: string;
}
